import { NgModule } from '@angular/core';
import { SsoRoutingModule } from './sso-routing.module';
import { SsoComponent } from './sso.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SsoComponent],
  imports: [
    TranslateModule,
    SsoRoutingModule
  ]
})
export class SsoModule { }
